import {
  LetterbooksTagConditionType,
} from "features/Letterbooks/types";
import LetterbooksParentContextType, { LetterbooksParentTagContextType } from "types/LetterbooksParentContextType";

export default function tagConditions(
  context: LetterbooksParentContextType
): LetterbooksTagConditionType {
  const { tag } = context as LetterbooksParentTagContextType;

  return {
    tag_category_slug: tag.tagCategory.slug,
    tag_slug: tag.slug,
  };
}
